import { useMutation, useQueryClient } from 'react-query'

import { permissionRepository } from '@webapp/platform/iam/data-access/repositories/PermissionRepository'
import { reportAccessGrantListQueryKeyPrefix } from '@webapp/platform/iam/query-configs/reportAccessGrant'

export const useMutateGrantReportAccessToAllSecondaryCategories = () => {
  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ({
      primaryCategoryId,
      userAuthId,
    }: {
      primaryCategoryId: number
      userAuthId: number
    }) =>
      permissionRepository.grantReportAccessToAllSecondaryCategories({
        primaryCategoryId,
        userAuthId,
      }),
    onSuccess: () => {
      // Every SecondaryCategory in the PrimaryCategory changed — invalidate
      // all grants lists (partial prefix key, ADR-5)
      queryClient.invalidateQueries(reportAccessGrantListQueryKeyPrefix)
    },
  })

  return {
    grantReportAccessToAllSecondaryCategories: mutateAsync,
    isGranting: isLoading,
  }
}
